// Screens player names shown on public leaderboards. The apps use a
// bad-word package; this is a small equivalent for the web: lowercase, undo
// common letter swaps (0 -> o, 1 -> i, $ -> s ...), drop spaces and _ and look
// for blocked words anywhere in the name. Strict on purpose: a rejected
// player just picks another name.

const SWAPS = {
  0: 'o', 1: 'i', 2: 'z', 3: 'e', 4: 'a', 5: 's', 6: 'g', 7: 't', 8: 'b', 9: 'g', '@': 'a', $: 's', '!': 'i', '|': 'i',
};

// Matched anywhere in the squashed name.
const ANYWHERE = [
  'fuck', 'fuk', 'fck', 'shit', 'bitch', 'cunt', 'dick', 'pussy', 'penis', 'vagina', 'asshole', 'arsehole',
  'bastard', 'whore', 'slut', 'porn', 'nude', 'boob', 'tits', 'dildo', 'jizz', 'wank', 'twat', 'bollock',
  'nigg', 'fag', 'retard', 'kike', 'tranny', 'dyke', 'gook', 'wetback', 'nazi', 'hitler', 'kkk',
  'molest', 'incest', 'killyourself', 'motherf', 'suckmy', 'blowjob', 'handjob', 'milf', 'onlyfans', 'horny',
];

// Matched only as a whole word, because they hide inside ordinary words
// (cucumber, analyst, grape, therapist, torpedo, peacock, raccoon).
const WHOLE_WORD = [
  'ass', 'arse', 'hoe', 'ho', 'tit', 'cum', 'anal', 'anus', 'sex', 'rape', 'rapist', 'pedo', 'paedo', 'cock',
  'spic', 'coon', 'nig', 'jap', 'chink', 'gay', 'homo', 'isis', 'kys', 'die',
];

const squash = (s) => s.toLowerCase().split('').map((ch) => SWAPS[ch] || ch).join('');

export function isCleanName(name) {
  const lower = squash(name);
  const joined = lower.replace(/[^a-z]/g, '');
  // Also catch stretched letters ("fuuuck").
  const deduped = joined.replace(/(.)\1+/g, '$1');
  if (ANYWHERE.some((w) => joined.includes(w) || deduped.includes(w))) return false;
  const words = lower.split(/[^a-z]+/).filter(Boolean);
  return !words.some((w) => WHOLE_WORD.includes(w) || WHOLE_WORD.includes(w.replace(/(.)\1+/g, '$1')));
}
